export default {
  statuses: [],
  products: [],
  count: 0,
  lastFilter: {},
};



// WEBPACK FOOTER //
// ./src/store/modules/product/state.js